import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'
import _ from 'lodash'
import { settingsDefaultValues } from 'utils/constants/settings-constants'

const selectSetting = createSelector(
	[
		(state) => {
			return state.data[dataConstants.SETTINGS];
		},
		(state, name) => {
			return name;
		}
	],
	( settings, name ) => {
		return _.get( settings, name, _.get( settingsDefaultValues, name, null ) );
	}
)

export default selectSetting;
